import { CircularProgress, Dialog, DialogContent, DialogContentText, DialogTitle, Stack, Typography } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

const DialogLoading = ({ props }) => {
  const component = (
    <Dialog open={props.show} aria-labelledby={props.title} aria-describedby={props.description}>
      <DialogTitle>{props.title}</DialogTitle>
      <Stack direction='column' alignItems='center' justifyContent='center' spacing={1} sx={{ width: 300 }} pb={2}>
        <Typography variant='body1'>{props.description}</Typography>
        <CircularProgress />
      </Stack>
    </Dialog>
  );
  return component;
};

DialogLoading.propTypes = {
  props: PropTypes.string.isRequired,
};

export default DialogLoading;
